import React from 'react';
import './style.scss';
import { Table } from 'react-bootstrap';
import {
  Delete, Pencil, Snack,
} from '../../../../../components/atoms/icons';
import Modal from '../../../../../components/organisms/modals';
import { DAYS, successUpdateMsg } from '../../../../../components/atoms/const';

interface Props {
  data: any;
  deleteLoading: boolean;
  // eslint-disable-next-line no-unused-vars
  handleDelete: (routeId: number, clientId: number) => void;
  result: any;
  onAfterResult: () => any;
  // eslint-disable-next-line no-unused-vars
  onNavigateRowEdit: (clientId: number) => any;
}

function RenderTable(props: Props): React.ReactElement {
  const {
    data, onNavigateRowEdit, deleteLoading, handleDelete, result, onAfterResult,
  } = props;

  const thLabel = ['TIME RANGE', 'CLIENT', 'LOCATION', 'VENDING MACHINE', 'SERVICE DAY', 'ACTIONS'];

  const driverData = data?.data?.data;
  const clientList = data?.data?.data?.clients;
  const deleteResult = result?.data?.success;

  const renderModalBody = ():string => {
    if (!deleteResult) return 'Are you sure? Do you want to delete this Client';
    return successUpdateMsg.SUCCESS_DELETE_CLIENT_BY_ROUTE_MSG;
  };

  const getTh = (value: string | number) => (
    <th>
      <div className="my-2 fz-14 fw-normal">{value}</div>
    </th>
  );
  return (
    <div className="table-container">
      <h6 className="fz-18 fw-bold mt-2 ms-2 ps-4">Client Details</h6>
      <Table borderless responsive>
        <thead>
          <tr>
            <th>&nbsp;</th>
            {thLabel.map((th) => (
              <th className="thead-content" key={th} style={th !== 'ACTIONS' ? { minWidth: '150px' } : { width: '50px' }}>{th}</th>
            ))}
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {clientList && clientList.length ? clientList.map((client: any, i: number) => (
            <tr key={client.id} className={(i % 2) ? 'tbody-content align-middle' : 'align-middle'}>
              <th>&nbsp;</th>
              {/* {getTh(obj.timeRange)} */}
              {getTh(client.timeRange)}
              {getTh(client.name)}
              {getTh(client.address)}
              <th>
                {client.vendingMachines.map((vendingMachine: any) => (
                  <div className="my-2 fz-14 fw-normal d-flex" key={vendingMachine}>
                    <div style={{ marginTop: '-1px' }}><Snack /></div>
                    <div className="ms-1">{vendingMachine}</div>
                  </div>
                ))}
              </th>
              {getTh(DAYS[driverData.day])}
              <th>
                <div className="d-flex my-2 justify-content-between align-items-center w-100 px-1">
                  <Modal.Default
                    cancelLabel="No"
                    submitLabel="Yes"
                    title="Delete Client"
                    body={renderModalBody()}
                    onSubmit={() => handleDelete(driverData.id, client.id)}
                    dialogClassName="custom-modal-width"
                    isLoading={deleteLoading}
                    result={deleteResult}
                    onAfterResult={onAfterResult}
                  >
                    <div style={{ marginBottom: '2px' }}>
                      <Delete width={18} />
                    </div>
                  </Modal.Default>
                  <button
                    type="button"
                    onClick={() => onNavigateRowEdit(client.id)}
                    className="bg-transparent border-0"
                  >
                    <Pencil width={20} />
                  </button>
                </div>
              </th>
            </tr>
          )) : (
            <tr>
              <th colSpan={8} className="text-center fw-normal fz-14">Data Not Found</th>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}

export default RenderTable;
